export class PromotionCampaignModel {
  id?: number;
  code: string;
  start_date: Date;
  end_date: Date;
  start_redem_date: Date;
  end_redem_date: Date;
  description: string;
  small_description: string;
  campaign_type_id: number;
  priority: number;
  flag_pressure_rules: string;
  wizard_id: number;
}

export class PromotionCampaignDetailModel {
  id?: number ;
  campaign_id: number ;
  message_id: number ;
  start_date: Date ;
  end_date: Date ;
  start_redem_date: Date ;
  end_redem_date: Date ;
  description: string ;
  dsnList: number[];
}




// WEBPACK FOOTER //
// ./src/app/models/promotion-campaign.model.ts